import React, { useContext, useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppContext from '../../Services/AppContext';
import PersistantData from '../../Services/PersistantData';
import {
	ck_u_client,
	ck_u_username,
	req_manage_users,
	req_manage_users_status,
	req_manage_users_password,
	req_manage_users_profile,
	req_role,
	req_working_shift_list,
	req_module_setting,
	empty,
	ADMIN_POSITION_PROMOTER
} from '../../Helper/Constants';
import JString from '@easytech-international-sdn-bhd/jstring';
import CryptData from '../../Helper/CryptData';
import { useSnackbar } from 'notistack';
import API_Service, { axiosDefaultConfig, axiosPutConfig, axiosURIencode } from '../../Services/API_Service';
import LinearLoading from '../../Components/LinearLoading';
import useCookieHook from '../../Services/useCookieHook';
import { de, getCountryIso2, isPromoter, withPromoterRole, resolveRolePayload } from '../../Helper/Helper';
import Papa from "papaparse";
import { saveAs } from "file-saver";
import UserPageHeader from './components/UserPageHeader';
import UserListTable from './components/UserListTable';
import UserFormDialog from './components/UserFormDialog';
import { UserListSkeleton } from './components/UserListStates';

/* work_start_time/work_end_time moved to Working Shift — manual time options no longer used
const TIME_OPTIONS = (function () {
	var arr = [];
	for (var h = 0; h < 24; h++) {
		var hh = h < 10 ? '0' + h : '' + h;
		arr.push(hh + ':00');
	}
	return arr;
})();
*/

const parseRestDays = (val) => {
	if (!val) return [];
	if (Array.isArray(val)) return val.map((v) => parseInt(v, 10)).filter((v) => !isNaN(v));
	return String(val).split(',').map((v) => parseInt(v, 10)).filter((v) => !isNaN(v));
};

const EMPTY_PROFILE = {
	ic_no: '',
	address: '',
	phone_number: '',
	// work_start_time: '', // moved to Working Shift (shift_id)
	// work_end_time: '',
	shift_id: '',
	rest_days: [],
	rest_repeat_weeks: '',
	rest_start_date: '',
	bank_name: '',
	bank_account_no: '',
	bank_account_name: ''
};

const useStyles = makeStyles((theme) => ({
	root: {
		paddingTop: theme.spacing(1),
	},
}));

export default function ManageUsers() {
	const classes = useStyles();
	const [gState] = useContext(AppContext);
	const singleton = PersistantData.getInstance();

	var { translation: language, client } = gState;
	if (typeof language === 'undefined') {
		language = singleton.getlang();
	}

	const { enqueueSnackbar } = useSnackbar();

	const [cookies] = useCookieHook([ck_u_client, ck_u_username]);
	const defUsername = cookies(ck_u_username);
	var u_client = cookies(ck_u_client);
	if (JString(defUsername).isValid()) {
		u_client = JString(u_client).isValid()
			? new CryptData(u_client, defUsername).decryptAES().getValue()
			: empty;
	}

	const [isLoading, setIsLoading] = useState(true);
	const [isRefreshing, setIsRefreshing] = useState(false);
	const [isCreating, setIsCreating] = useState(false);

	const [usersList, setUsersList] = useState([]);
	const [tableData, setTableData] = useState([]);
	const [quota, setQuota] = useState({ active_count: 0, max_users: 0 });

	const [createOpen, setCreateOpen] = useState(false);
	const [newUsername, setNewUsername] = useState(empty);
	const [newName, setNewName] = useState(empty);
	const [newPassword, setNewPassword] = useState(empty);
	const [showNewPassword, setShowNewPassword] = useState(false);

// 	const [changePasswordOpen, setChangePasswordOpen] = useState(false);
// 	const [selectedUser, setSelectedUser] = useState(null);
// 	const [newPasswordInput, setNewPasswordInput] = useState(empty);
// 	const [showPasswordInput, setShowPasswordInput] = useState(false);
// 	const [isChangingPassword, setIsChangingPassword] = useState(false);

	const [searchQuery, setSearchQuery] = useState(empty);
	const [statusFilter, setStatusFilter] = useState('all');
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [togglingId, setTogglingId] = useState(null);

	const [axiosConfig, setAxiosConfig] = useState({});

	const [newProfile, setNewProfile] = useState(EMPTY_PROFILE);
	const [newRole, setNewRole] = useState(empty);
	const [roleList, setRoleList] = useState([]);
	const [workingShiftEnabled, setWorkingShiftEnabled] = useState(false);
	const [countryIso2, setCountryIso2] = useState('my');
	const [shiftList, setShiftList] = useState([]);

	const [editOpen, setEditOpen] = useState(false);
	const [editingUser, setEditingUser] = useState(null);
	const [editForm, setEditForm] = useState({ username: '', name: '', password: '', role_id: '', ...EMPTY_PROFILE });
	const [showEditPassword, setShowEditPassword] = useState(false);
	const [isSavingEdit, setIsSavingEdit] = useState(false);

	useEffect(() => { setPage(0); }, [searchQuery, statusFilter]);

	useEffect(() => {
		if (JString(gState.client).isValid()) {
			var config = axiosDefaultConfig(gState.client);
			setAxiosConfig(config);
			loadUsers(config);
			loadRoles(config);
			loadModulesAndShifts(config);
		}
	}, [u_client, gState.client]);

	const snack = (msg, type = 'success') => {
		enqueueSnackbar(msg, {
			variant: type,
			preventDuplicate: true,
			autoHideDuration: type === 'success' ? 2000 : 3000
		});
	};

	const loadUsers = (config) => {
		setIsRefreshing(true);
		API_Service.get(req_manage_users, config || axiosConfig)
			.then(({ data }) => {
				if (data) {
					var { result, extraData } = data;
					result = JString(result).toNumber();
					if (result === 1) {
						var { users, quota: quotaData } = extraData;
						setUsersList(users || []);
						setQuota(quotaData || { active_count: 0, max_users: 0 });

						var _tableData = (users || []).map((user) => ({
							username: user.username,
							name: user.name,
							active_status: user.active_status,
							login_id: user.login_id,
							created_at: user.created_at,
							inactive_date: user.inactive_date,
							updated_at: user.updated_at,
							updated_by: user.updated_by,
							role_name: user.role_name,
							position: user.position
						}));
						setTableData(_tableData);
						setPage(0);
					}
				}
			})
			.catch(de)
			.finally(() => {
				setIsLoading(false);
				setIsRefreshing(false);
			});
	};

	const loadRoles = (config) => {
		API_Service.get(req_role, config || axiosConfig)
			.then(({ data }) => {
				if (data) {
					var { result, extraData } = data;
					result = JString(result).toNumber();
					if (result === 1) {
						setRoleList(withPromoterRole(extraData || [], language.promoter));
					}
				}
			})
			.catch(de);
	};

	const loadModulesAndShifts = (config) => {
		// working_shift gate removed — Working Shift shown for all clients (was gated by modules.working_shift)
		setWorkingShiftEnabled(true);
		loadShifts(config);
		loadCountry(config);
	};

	const loadCountry = (config) => {
		API_Service.get(req_module_setting, config || axiosConfig)
			.then(({ data }) => {
				if (data) {
					var { result, extraData } = data;
					result = JString(result).toNumber();
					if (result === 1) {
						setCountryIso2(getCountryIso2(extraData));
					}
				}
			})
			.catch(() => snack(language.operation_fail, 'error'));
	};

	const loadShifts = (config) => {
		API_Service.get(req_working_shift_list, config || axiosConfig)
			.then(({ data }) => {
				if (data) {
					var { result, extraData } = data;
					result = JString(result).toNumber();
					if (result === 1) {
						var active = (extraData || []).filter((s) => parseInt(s.status, 10) === 1);
						setShiftList(active);
					} else {
						setShiftList([]);
					}
				}
			})
			.catch(() => snack(language.operation_fail, 'error'));
	};

	const createUser = () => {
		var nUsername = JString(newUsername);
		var nName = JString(newName);
		var nPassword = JString(newPassword);

		if (!(nUsername.isValid() && nUsername.str.length > 2)) {
			snack(language.username_error, 'error');
			return;
		}
		if (!nName.isValid()) {
			snack(language.name_label + ' ' + language.is_required, 'error');
			return;
		}
		if (!(nPassword.isValid() && nPassword.str.length > 3)) {
			snack(language.password_error, 'error');
			return;
		}
		if (!newRole || (newRole !== ADMIN_POSITION_PROMOTER && JString(newRole).toNumber() <= 0)) {
			snack((language.select_role || 'Select Role') + ' ' + (language.is_required || 'is required'), 'error');
			return;
		}
		if (newProfile.rest_repeat_weeks && !newProfile.rest_start_date) {
			snack(language.rest_start_date_required, 'error');
			return;
		}

		setIsCreating(true);
		var formdata = new FormData();
		formdata.append('username', nUsername.str);
		formdata.append('name', nName.str);
		formdata.append('password', nPassword.str);
		var newRolePayload = resolveRolePayload(newRole, roleList);
		formdata.append('role_id', newRolePayload.role_id);
		formdata.append('position', newRolePayload.position);
		appendProfileFields(formdata, newProfile);

		API_Service.post(req_manage_users, formdata, axiosConfig)
			.then(({ data }) => {
				if (data) {
					var { result } = data;
					result = JString(result).toNumber();
					if (result === 1) {
						snack(language.user_saved);
						clearForm();
						setCreateOpen(false);
						loadUsers();
					} else if (result === 2) {
						snack(language.user_exists_active, 'error');
					} else if (result === 3) {
						snack(language.quota_exceeded, 'error');
					} else {
						snack(language.operation_fail, 'error');
					}
				}
			})
			.catch(() => snack(language.operation_fail, 'error'))
			.finally(() => setIsCreating(false));
	};

	const clearForm = () => {
		setNewUsername(empty);
		setNewName(empty);
		setNewPassword(empty);
		setShowNewPassword(false);
		setNewProfile(EMPTY_PROFILE);
		setNewRole(empty);
	};

	const openCreate = () => {
		setCreateOpen(true);
	};

	const closeCreate = () => {
		setCreateOpen(false);
		clearForm();
	};

	const appendProfileFields = (formdata, src) => {
		formdata.append('ic_no', src.ic_no || '');
		formdata.append('address', src.address || '');
		formdata.append('phone_number', src.phone_number || '');
		// formdata.append('work_start_time', src.work_start_time || ''); // moved to Working Shift (shift_id)
		// formdata.append('work_end_time', src.work_end_time || '');
		formdata.append('shift_id', src.shift_id || '');
		formdata.append('rest_days', (src.rest_days || []).join(','));
		formdata.append('rest_repeat_weeks', src.rest_repeat_weeks === '' ? '' : src.rest_repeat_weeks);
		formdata.append('rest_start_date', src.rest_start_date || '');
		formdata.append('bank_name', src.bank_name || '');
		formdata.append('bank_account_no', src.bank_account_no || '');
		formdata.append('bank_account_name', src.bank_account_name || '');
	};

	const setProfileField = (key, value) => {
		setNewProfile((prev) => ({ ...prev, [key]: value }));
	};

	const setCreateField = (key, value) => {
		if (key === 'name') {
			setNewName(value);
		} else if (key === 'username') {
			setNewUsername(value.replace(/\s/g, ''));
		} else if (key === 'password') {
			setNewPassword(value.replace(/\s/g, ''));
		} else if (key === 'role_id') {
			setNewRole(value);
		} else {
			setProfileField(key, value);
		}
	};

	const toggleProfileRestDay = (dayValue, isEdit) => {
		var update = (prev) => {
			var existing = prev.rest_days || [];
			var next = existing.includes(dayValue)
				? existing.filter((d) => d !== dayValue)
				: [...existing, dayValue].sort((a, b) => a - b);
			return { ...prev, rest_days: next };
		};
		if (isEdit) {
			setEditForm(update);
		} else {
			setNewProfile(update);
		}
	};

	const setEditField = (key, value) => {
		if (key === 'password') {
			value = value.replace(/\s/g, '');
		}
		setEditForm((prev) => ({ ...prev, [key]: value }));
	};

	const openEdit = (loginId) => {
		var user = usersList.find((u) => String(u.login_id) === String(loginId));
		if (!user) return;
		setEditingUser(user);
		setEditForm({
			username: user.username || '',
			name: user.name || '',
			password: '',
			role_id: isPromoter(user.position) ? ADMIN_POSITION_PROMOTER : (user.role_id ? String(user.role_id) : ''),
			ic_no: user.ic_no || '',
			address: user.address || '',
			phone_number: user.phone_number || '',
			// work_start_time: normalizeTime(user.work_start_time), // moved to Working Shift (shift_id)
			// work_end_time: normalizeTime(user.work_end_time),
			shift_id: user.shift_id ? String(user.shift_id) : '',
			rest_days: parseRestDays(user.rest_days),
			rest_repeat_weeks: user.rest_repeat_weeks ? String(user.rest_repeat_weeks) : '',
			rest_start_date: user.rest_start_date || '',
			bank_name: user.bank_name || '',
			bank_account_no: user.bank_account_no || '',
			bank_account_name: user.bank_account_name || ''
		});
		setShowEditPassword(false);
		setEditOpen(true);
	};

	const closeEdit = () => {
		setEditOpen(false);
		setEditingUser(null);
		setEditForm({ username: '', name: '', password: '', role_id: '', ...EMPTY_PROFILE });
		setShowEditPassword(false);
	};

	const saveEdit = () => {
		if (!editingUser) return;

		var eName = JString(editForm.name);
		if (!eName.isValid()) {
			snack(language.name_label + ' ' + language.is_required, 'error');
			return;
		}
		var newPw = JString(editForm.password);
		if (editForm.password && editForm.password.length > 0 && !(newPw.isValid() && newPw.str.length > 3)) {
			snack(language.password_error, 'error');
			return;
		}
		if (editForm.rest_repeat_weeks && !editForm.rest_start_date) {
			snack(language.rest_start_date_required, 'error');
			return;
		}
		if (!editForm.role_id || (editForm.role_id !== ADMIN_POSITION_PROMOTER && JString(editForm.role_id).toNumber() <= 0)) {
			snack((language.select_role || 'Select Role') + ' ' + (language.is_required || 'is required'), 'error');
			return;
		}

		setIsSavingEdit(true);

		var editRolePayload = resolveRolePayload(editForm.role_id, roleList);
		var profileParams = axiosURIencode({
			login_id: editingUser.login_id,
			name: eName.str,
			role_id: editRolePayload.role_id,
			position: editRolePayload.position,
			ic_no: editForm.ic_no || '',
			address: editForm.address || '',
			phone_number: editForm.phone_number || '',
			// work_start_time: editForm.work_start_time || '', // moved to Working Shift (shift_id)
			// work_end_time: editForm.work_end_time || '',
			shift_id: editForm.shift_id || '',
			rest_days: (editForm.rest_days || []).join(','),
			rest_repeat_weeks: editForm.rest_repeat_weeks === '' ? '' : editForm.rest_repeat_weeks,
			rest_start_date: editForm.rest_start_date || '',
			bank_name: editForm.bank_name || '',
			bank_account_no: editForm.bank_account_no || '',
			bank_account_name: editForm.bank_account_name || ''
		});

		var profilePromise = API_Service.put(req_manage_users_profile, profileParams, axiosPutConfig(gState.client));

		var passwordPromise = Promise.resolve({ data: { result: 1 } });
		if (editForm.password && editForm.password.length > 0) {
			var pwParams = axiosURIencode({
				login_id: editingUser.login_id,
				new_password: editForm.password
			});
			passwordPromise = API_Service.put(req_manage_users_password, pwParams, axiosPutConfig(gState.client));
		}

		Promise.all([profilePromise, passwordPromise])
			.then((results) => {
				var profileRes = JString(results[0].data && results[0].data.result).toNumber();
				var pwRes = JString(results[1].data && results[1].data.result).toNumber();
				if (profileRes === 1 && pwRes === 1) {
					snack(language.user_updated || 'User updated');
					closeEdit();
					loadUsers();
				} else {
					snack(language.operation_fail, 'error');
				}
			})
			.catch(() => snack(language.operation_fail, 'error'))
			.finally(() => setIsSavingEdit(false));
	};

	const toggleStatus = (loginId, currentStatus) => {
		var newStatus = currentStatus == 1 ? 0 : 1;
		var params = axiosURIencode({
			login_id: loginId,
			active_status: newStatus
		});

		setTogglingId(loginId);
		API_Service.put(req_manage_users_status, params, axiosPutConfig(gState.client))
			.then(({ data }) => {
				if (data) {
					var { result } = data;
					result = JString(result).toNumber();
					if (result === 1) {
						snack(newStatus === 1 ? language.user_activated : language.user_deactivated);
						loadUsers();
					} else if (result === 3) {
						snack(language.quota_exceeded, 'error');
					} else {
						snack(language.operation_fail, 'error');
					}
				}
			})
			.catch(() => snack(language.operation_fail, 'error'))
			.finally(() => setTogglingId(null));
	};

// Change Password — merged into Edit User dialog (saveEdit handles password)
// 	const openChangePassword = (username, loginId) => {
// 		setSelectedUser({ username, login_id: loginId });
// 		setNewPasswordInput(empty);
// 		setShowPasswordInput(false);
// 		setChangePasswordOpen(true);
// 	};

// 	const changePassword = () => {
// 		if (!selectedUser) return;
// 		var nPw = JString(newPasswordInput);
// 		if (!(nPw.isValid() && nPw.str.length > 3)) {
// 			snack(language.password_error, 'error');
// 			return;
// 		}

// 		setIsChangingPassword(true);
// 		var params = axiosURIencode({
// 			login_id: selectedUser.login_id,
// 			new_password: nPw.str
// 		});

// 		API_Service.put(req_manage_users_password, params, axiosPutConfig(gState.client))
// 			.then(({ data }) => {
// 				if (data) {
// 					var { result } = data;
// 					result = JString(result).toNumber();
// 					if (result === 1) {
// 						snack(language.password_changed);
// 						setChangePasswordOpen(false);
// 						setSelectedUser(null);
// 						setNewPasswordInput(empty);
// 					} else {
// 						snack(language.operation_fail, 'error');
// 					}
// 				}
// 			})
// 			.catch(() => snack(language.operation_fail, 'error'))
// 			.finally(() => setIsChangingPassword(false));
// 	};

	var vUsername = newUsername.length === 0 ? false : newUsername.length > 2;
	var vPassword = newPassword.length === 0 ? false : newPassword.length > 3;
	var canSave = newUsername.length > 2 && newName.length > 0 && newPassword.length > 3 && (newRole === ADMIN_POSITION_PROMOTER || JString(newRole).toNumber() > 0);

	var createForm = {
		name: newName,
		username: newUsername,
		password: newPassword,
		role_id: newRole,
		...newProfile
	};
	var createErrors = {
		username: newUsername.length > 0 && !vUsername,
		password: newPassword.length > 0 && !vPassword
	};

	var activeCount = tableData.filter((r) => r.active_status == 1).length;
	var inactiveCount = tableData.filter((r) => r.active_status == 0).length;
	var totalCount = tableData.length;

	var filteredUsers = tableData.filter((row) => {
		if (statusFilter === 'active' && row.active_status != 1) return false;
		if (statusFilter === 'inactive' && row.active_status != 0) return false;
		if (!searchQuery) return true;
		var q = searchQuery.toLowerCase();
		return (
			(row.username || '').toLowerCase().includes(q) ||
			(row.name || '').toLowerCase().includes(q)
		);
	});
	filteredUsers.sort((a, b) => b.active_status - a.active_status);

	var paginatedUsers = filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

	var hasFilter = statusFilter !== 'all' || searchQuery !== '';

	const clearFilters = () => {
		setStatusFilter('all');
		setSearchQuery(empty);
	};

	var exportCSV = function () {
		if (filteredUsers.length === 0) return;
		var csvData = filteredUsers.map(function (row, index) {
			return {
				'No.': index + 1,
				'Username': row.username,
				'Name': row.name,
				'Status': row.active_status == 1 ? 'Active' : 'Inactive'
			};
		});
		var csv = Papa.unparse(csvData);
		var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
		saveAs(blob, "Users.csv");
	};

	var quotaPercentage = quota.max_users > 0
		? Math.min((quota.active_count / quota.max_users) * 100, 100)
		: 0;
	var atCapacity = quota.max_users > 0 && quota.active_count >= quota.max_users;
	var nearCapacity = !atCapacity && quotaPercentage >= 80;
	var quotaStatus = atCapacity ? 'atCapacity' : nearCapacity ? 'nearCapacity' : 'normal';

	if (isLoading) {
		return <UserListSkeleton />;
	}

	return (
		<div className={classes.root}>
			{isRefreshing && <LinearLoading />}

			<UserPageHeader
				language={language}
				shown={filteredUsers.length}
				total={totalCount}
				quota={quota}
				quotaStatus={quotaStatus}
				quotaPercentage={quotaPercentage}
				statusFilter={statusFilter}
				counts={{ all: totalCount, active: activeCount, inactive: inactiveCount }}
				onStatusFilterChange={setStatusFilter}
				searchValue={searchQuery}
				onSearchChange={setSearchQuery}
				onExport={exportCSV}
				exportDisabled={filteredUsers.length === 0}
				onCreate={openCreate}
			/>

			<UserListTable
				language={language}
				rows={paginatedUsers}
				count={filteredUsers.length}
				page={page}
				rowsPerPage={rowsPerPage}
				onPageChange={(e, newPage) => setPage(newPage)}
				onRowsPerPageChange={(e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }}
				onEdit={openEdit}
				onToggleStatus={toggleStatus}
				togglingId={togglingId}
				showClear={hasFilter}
				onClear={clearFilters}
			/>

			<UserFormDialog
				open={createOpen}
				mode="create"
				language={language}
				form={createForm}
				errors={createErrors}
				onFieldChange={setCreateField}
				onToggleRestDay={(dayValue) => toggleProfileRestDay(dayValue, false)}
				roleList={roleList}
				shiftList={shiftList}
				countryIso2={countryIso2}
				workingShiftEnabled={workingShiftEnabled}
				showPassword={showNewPassword}
				onToggleShowPassword={() => setShowNewPassword(!showNewPassword)}
				onClose={closeCreate}
				onSubmit={createUser}
				submitting={isCreating}
				canSubmit={canSave}
			/>

			{/* Change Password dialog — merged into Edit User dialog (New Password field) */}

			<UserFormDialog
				open={editOpen}
				mode="edit"
				language={language}
				form={editForm}
				onFieldChange={setEditField}
				onToggleRestDay={(dayValue) => toggleProfileRestDay(dayValue, true)}
				roleList={roleList}
				shiftList={shiftList}
				countryIso2={countryIso2}
				workingShiftEnabled={workingShiftEnabled}
				showPassword={showEditPassword}
				onToggleShowPassword={() => setShowEditPassword(!showEditPassword)}
				onClose={closeEdit}
				onSubmit={saveEdit}
				submitting={isSavingEdit}
				canSubmit={true}
			/>
		</div>
	);
}
